import gql from 'graphql-tag';

export const PriceTierBase = `
    id
    __typename
    price
    name
    description
    priceTierID
    networkID
    network {
      __typename
      id
    }
    instanceIDs
    fallbackIncrement
    fallbackAmount
    dynamicPrice
    minPrice
    maxPrice
    agentResponsiblePercentage
    allowedFilters
    fallbackPriceTierID
    status
    marketplace
    vertical
    liveTransfers
    liveTransferPrice
    isAged
    isOverflow
    chargeDelayThreshold
    agentCreditOnly
    skipDupCheck
    addDupBackToQueue
    allowedDestinationTypes
    bulkPurchase
    bulkPurchaseMax
    bulkPurchaseTimeout
    bulkPurchaseCustom
    bulkPurchaseTimeoutOverride
    tierType
    requiredDestination
    maxLeadCountPerDay
    maxDuplicates
    analyticStreamOn
    tierType
    maxLeadCountPerDay
    maxCampaignCount
    tierType
    bulkPurchaseOnly
    handlerV2
    concurrencyLimit
    spendingPeriodSubsetCount
    isOptic
    tierV4
    makeTierCopy
    totalNoMatch
    queryLimit
    vcConcurrency
    brokerID
    cbNewAdmin
    filters {
      rangeFilters {
        splitCountInt {
          min
          max
        }
      }
    }
`;

const PriceTierFragment = gql`
  fragment PriceTierFragment on PriceTier {
    ${PriceTierBase}
    assignedAgents
    activeSpendingPeriods
    totalCampaigns
    assignedLiveTransferLayers {
      description
      liveTransferPhoneNumber
      vendorID
      layerID
    }
    mpVendorCampaignIDs
    overflowMpVendorCampaignIDs
    redisPriceTier{
      status
      serverStatus
      cycleDuration
      lastCompletionEpoch
    }
    priceBreakPoints {
      breakPoint
      breakPointPrice
    }
    bulkPurchaseMin
  }`;

export const PriceTierBaseFragment = gql`
  fragment PriceTierFragment on PriceTier {
    ${PriceTierBase}
  }`;

export default PriceTierFragment;
